import { motion } from 'motion/react';

const DotsLoader = () => (
  <div className="flex items-center justify-center">
    <div className="flex space-x-2">
      <motion.div
        animate={{
          scale: [1, 1.5, 1],
          opacity: [0.5, 1, 0.5],
        }}
        className="h-2 w-2 rounded-full bg-system-disabled-400"
        transition={{
          duration: 1,
          ease: 'easeInOut',
          repeat: Infinity,
        }}
      />
      <motion.div
        animate={{
          scale: [1, 1.5, 1],
          opacity: [0.5, 1, 0.5],
        }}
        className="h-2 w-2 rounded-full bg-system-disabled-400"
        transition={{
          duration: 1,
          ease: 'easeInOut',
          repeat: Infinity,
          delay: 0.3,
        }}
      />
      <motion.div
        animate={{
          scale: [1, 1.5, 1],
          opacity: [0.5, 1, 0.5],
        }}
        className="h-2 w-2 rounded-full bg-system-disabled-400"
        transition={{
          duration: 1,
          ease: 'easeInOut',
          repeat: Infinity,
          delay: 0.6,
        }}
      />
    </div>
  </div>
);
export default DotsLoader;
